
















import Vue from 'vue'

import { SettingsPanelCustomCustomMixin } from './SettingsPanelCustomCustomMixin'
import SettingsPanelCustomSelectbox from '../SettingsPanelCustomSelectbox.vue'

import { WidgetSettingType, WidgetSettingsSelectbox } from '../../widgets/base/widget/WidgetInterface'

import { googleMaps, openStreetMap } from '../../widgets/map/MapProvider'

export default Vue.extend({
  mixins: [SettingsPanelCustomCustomMixin],
  components: {
    SettingsPanelCustomSelectbox
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: {}
    }
  },
  data() {
    const config = {
      mapProvider: 'openStreetMap',
      mapType: 'basemap'
    }

    this.syncConfigProperties(config, this.data)

    return {
      config
    }
  },
  computed: {
    availableMapTypes() {
      let mapTypesSelect: WidgetSettingsSelectbox = {
        title: 'Kartentyp',
        type: WidgetSettingType.selectbox,
        options: [],
        value: this.config.mapType,
      }

      let mapTypesData = {}

      switch (this.config.mapProvider) {
        case 'googleMaps':
          mapTypesData = googleMaps
          break;
        default:
            mapTypesData = openStreetMap
          break;
      }

      for (const key in mapTypesData) {
        mapTypesSelect.options.push({
          label: mapTypesData[key].name,
          value: key
        })
      }

      return mapTypesSelect
    }
  },
  methods: {
    getAvailableMapProvider(): WidgetSettingsSelectbox {
      let mapProviderSelect: WidgetSettingsSelectbox = {
        title: 'Kartenanbieter',
        type: WidgetSettingType.selectbox,
        options: [
          {
            label: 'Google Maps',
            value: 'googleMaps'
          },
          {
            label: 'Open Street Map',
            value: 'openStreetMap'
          }
        ],
        value: this.config.mapProvider,
      }

      return mapProviderSelect
    }
  },
  updated() {
    const config = this.config

    this.$emit('update', this.config)
  }
})
